import BaseService from "./base.service";

/**
 * Cliente do endpoint de ingestão de leads (POST /api/Leads/Capture).
 * O back-end repassa o evento à plataforma auc-captacao mantendo a X-Api-Key no servidor.
 *
 * É fire-and-forget: sem loader e sem alertas, e engole qualquer erro — a captura de lead
 * NUNCA pode atrapalhar o fluxo do usuário (envio de contato, simulação, etc.).
 */
export default class LeadsService extends BaseService {
    constructor() {
        super("Leads");
    }

    /**
     * @param {Object} dto - { source, campaignId?, campaignSlug?, institutionId?,
     *                          recipient: { email, cpf?, name?, phone? },
     *                          device?, metadata?, consent?, idempotencyKey? }
     */
    capture(dto) {
        // showMessage=false, showLoader=false → totalmente silencioso em background.
        return this.postRequest("Capture", dto, false, false).catch(() => {});
    }
}
